import React from 'react';
import LargeTooltip from './LargeTooltip';
import SVGIcon from './SVGIcon';
import informationIcon from '../icons/non-prefilled/16x16/information.svg';

const LargeInfoTooltip = ({
  content,
  trigger,
}: Pick<React.ComponentProps<typeof LargeTooltip>, 'content' | 'trigger'>) => (
  <LargeTooltip screenPadding={12} trigger={trigger} content={content} asChild>
    <SVGIcon size={14}>{informationIcon}</SVGIcon>
  </LargeTooltip>
);

export default LargeInfoTooltip;
